import { render, staticRenderFns } from "./ActivePush.vue?vue&type=template&id=5387249a&scoped=true"
import script from "./ActivePush.vue?vue&type=script&lang=js"
export * from "./ActivePush.vue?vue&type=script&lang=js"
import style0 from "./ActivePush.vue?vue&type=style&index=0&id=5387249a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387249a",
  null
  
)

export default component.exports